<span class="article-date nordic-blue-900-text font-body-2">
  <ng-container *ngIf="text">{{ text }} </ng-container>{{ date | finTimestamp }}
</span>
